import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AppService } from '@app/core/services/app.service';
import { CondominioService } from '@app/core/services/condominio.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert-push',
  templateUrl: './alert-push.component.html',
  styleUrls: ['./alert-push.component.scss']
})
export class AlertPushComponent implements OnInit {

  title: string;

  form: UntypedFormGroup;
  allSelected: boolean = false;
  buscaDeCondominioPorNome: any;
  mensagemDeFalhaCondominios: string;
  saving: boolean = false;
  updating: boolean = false;

  condominiosSelecionadoTotal: number = 0;
  condominios: any[] = []
  condominiosCopy: any[] = []

  constructor(
    private app: AppService,
    private condominioService: CondominioService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      titulo: new UntypedFormControl('', Validators.required),
      descricao: new UntypedFormControl('', Validators.required),
      condominiosIds: new UntypedFormControl([])
    });

    this.listarCondominios();

  }


  marcarTodos() {
    let totalSelecionados = 0;
    for (var i = 0; i < this.condominiosCopy.length; i++) {
      this.condominiosCopy[i].selecionado = this.allSelected;
      totalSelecionados++;
    }

    if (!this.allSelected) {
      this.condominiosSelecionadoTotal = 0;
      return;
    }

    this.condominiosSelecionadoTotal = totalSelecionados;
  }

  selecionarCondominio(condominio) {
    condominio.selecionado ? this.condominiosSelecionadoTotal = this.condominiosSelecionadoTotal + 1 : this.condominiosSelecionadoTotal = this.condominiosSelecionadoTotal - 1

    this.allSelected = this.condominiosCopy.every(function (item: any) {
      return item.selecionado == true;
    });
  }

  listarCondominios() {
    this.updating = true;
    this.condominioService.getCondominios().subscribe({
      next: response => {
        this.updating = false;
        this.condominiosSelecionadoTotal = 0;

        const condominio = response.map(condominio => condominio.selecionado = false);
        this.condominiosCopy = condominio;
        this.condominios = condominio;
      },
      error: erro => {
        this.updating = false;
        this.app.tratarErro(erro, 'Não foi possível carregar as comunidades.');
      }
    });

  }

  async enviar() {
    let condominiosIds = this.condominiosCopy.filter(condominio => condominio.selecionado).map(condominio => condominio.id);
    let form = this.form.value;
    form.condominiosIds = condominiosIds;
    // this.app.showLoading();
    this.saving = true;
    this.form.disable();
    const response: any = await this.condominioService.enviarPushPersonalizadoCondominios(form);

    if (response.status == 0) {
      this.form.enable();
      this.saving = false;
      this.app.alert("Enviado com sucesso");
      if (response.conteudo) {
        let idsCondominiosFalha: string[] = response.conteudo.split("|");

        this.mensagemDeFalhaCondominios = "Houve falha ao enviar o(s) condominio(s): ";

        idsCondominiosFalha.map(id => {
          let condo = this.condominios.find(c => c.id == parseInt(id));
          if (condo) {
            this.mensagemDeFalhaCondominios += condo.nome + " ";
          }
        });
      } else {
        this.mensagemDeFalhaCondominios = "";
      }
      return;
    }

    this.saving = false;

  }

  filtrarCondominio(event) {
    const termo = this.app.normalizeText(event);

    this.condominiosCopy = this.condominios.map(condominio => {
      const itemBuscado = this.app.normalizeText(condominio.nome);
      if (itemBuscado.includes(termo)) {
        return condominio;
      }
    }).filter(condominio => condominio != null);

  }

}
